import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormattedMessage } from 'react-intl';

import * as uuid from 'uuid';

import { ShareBoxArrowIcon } from '@notino/react-styleguide';

import { getWindowOrigin } from '@utils/constants';

import { wishlistMessages } from '../messages';

import { LinkSharerCircleBorder, IconTextButton } from './styled';
import { useCopyWishlistId } from './useCopyWishlistId';

export const LinkSharer: React.FC = () => {
  const anonymousId = React.useMemo(() => uuid(), []);

  const { handleOnCopy } = useCopyWishlistId(anonymousId);

  const hostUrl = getWindowOrigin();
  const showMobileSharing = async () => {
    await navigator.share({
      url: `${hostUrl}/wishlist?id=${anonymousId}`,
    });
  };

  const isSafariOnDesktop = () =>
    /Safari/i.test(navigator.userAgent) &&
    navigator.vendor.includes('Apple Computer') &&
    !/Mobi|Android/i.test(navigator.userAgent);

  const handleNativeShare = () =>
    navigator.share && !isSafariOnDesktop && showMobileSharing();

  return (
    <CopyToClipboard
      text={`${hostUrl}/wishlist?id=${anonymousId}`}
      onCopy={handleOnCopy}
    >
      <IconTextButton onClick={handleNativeShare} id="wishlist-copy-button">
        <LinkSharerCircleBorder>
          <ShareBoxArrowIcon width="16px" height="16px" />
        </LinkSharerCircleBorder>

        <FormattedMessage {...wishlistMessages.toggle} />
      </IconTextButton>
    </CopyToClipboard>
  );
};
